module.exports = __webpack_public_path__ + "img/Vector.7f983b9a.svg";